import { PAYMENT_TYPES } from '@sdk/account/constants';

export default class AccountOverviewCtrl {
  constructor(AccountService, Restangular, $scope, $rootScope, $state, billingInfo) {
    'ngInject';

    Object.assign(this, { AccountService, Restangular, $scope, $rootScope, $state, billingInfo });
    this.init();
  }

  init() {
    this.tabs = [{ label: 'Account', value: 'account.overview.account' }];

    if (this.billingInfo) {
      this.tabs = [...this.tabs, ...[{ label: 'Billing', value: 'account.overview.billing' }]];

      if (
        ![PAYMENT_TYPES.SHOPIFY_BILLING, PAYMENT_TYPES.TOAST_BILLING].includes(
          this.billingInfo.paymentType
        )
      ) {
        this.tabs.push({ label: 'Invoices', value: 'account.overview.invoices' });
      }
    }

    if (
      __STAGING__ &&
      this.billingInfo &&
      this.billingInfo.paymentType === PAYMENT_TYPES.ACH_CREDIT_TRANSFER &&
      this.billingInfo.achStatus
    ) {
      this.tabs = [
        ...this.tabs,
        ...[{ label: 'ACH testing', value: 'account.overview.ach-testing', testing: true }],
      ];
    }

    this.$scope.$on('socket:subscription:edit', async () => {
      const billingInfo = await this.AccountService.getBillingInfo();
      Object.assign(this.billingInfo, billingInfo);

      this.$rootScope.$broadcast('subscription-updated', this.billingInfo);
    });
  }

  get activeTab() {
    if (this.$state.current.name === 'account.overview.purchase') {
      return 'account.overview.billing';
    }

    return this.$state.current.name;
  }
}
